import { SmartLinkWidgetType } from './enums';
import type { SerializedWidget } from './types';

/**
 * The picture that a block shows, for the cover art checks of a page: the image of an Image block,
 * or the image of a Media block (the poster when its file is a video). Null for every other block,
 * and for a Media block with no ready file.
 *
 * The Image block folded into the Media block on 2026-10-08, so a cover check that reads only
 * Image blocks misses the cover of every new page.
 */
export function widgetPictureUrl(widget: SerializedWidget): string | null {
  if (widget.type === SmartLinkWidgetType.image) {
    return widget.data.imageProcessedUrl;
  }
  if (widget.type === SmartLinkWidgetType.media && widget.data.media !== null) {
    const { media } = widget.data;
    return media.kind === 'image' ? media.url : media.posterUrl;
  }
  return null;
}
